/**
 * Build an ASCII-only multipart filename for file uploads.
 * Edge WAF rules reject non-Latin characters in Content-Disposition filenames.
 */
export function toAsciiUploadFilename(fieldName: string, file: File): string {
  const rawExt = file.name.includes(".") ? (file.name.split(".").pop() ?? "") : "";
  const ext = rawExt.toLowerCase().replace(/[^a-z0-9]/g, "") || "bin";
  const base =
    fieldName
      .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
      .replace(/[^a-zA-Z0-9]+/g, "_")
      .replace(/^_|_$/g, "")
      .toLowerCase() || "document";
  return `${base}.${ext}`;
}
